export const config = {
  data() {
    return {
      columns:[
        {
          type:"selection",
          align: "center",
          width: "50",
        },
        {
          type:"index",
          title: "序号",
          align: "center",
          width: "50",
        },
        {
          title: "名称",
          key: "name",
          minWidth: 140,
          align: "center",
        },
        {
          title: "是否必填",
          slot: "key1",
          align: "center",
          minWidth: 70,
        },
        {
          title: "内容",
          key: "desc",
          align: "center",
          minWidth: 140,
          render(h, params) {
            let text = params.row.desc;
            return h(
                'Tooltip',
                {
                    class:'flex-center',
                    props: { placement: 'bottom-start', transfer: true }
                },
                [
                    h(
                        'span',
                        {
                            class: 'txt-ellipsis2'
                        },
                        text
                    ),
                    h('span', { slot: 'content'}, text)
                ]
            );
        }
        },
      ],
    }
  },
  methods: {

  }
}
